import './styles.scss'
import { IconMessage } from '@tabler/icons-react'
import { Text } from '@fragments'
import { useChatPanel } from '../ChatPanelContext'
import { useSidebar } from '../../Sidebar/SidebarContext'

function getInitials(name = '') {
    const parts = name.trim().split(/\s+/)
    if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase()
    return (parts[0][0] + (parts[parts.length - 1]?.[0] || '')).toUpperCase()
}

export default function ChatFloatingButton({ inline = false }) {
    const { toggle, chats, totalUnread, open } = useChatPanel()
    const { isMobile } = useSidebar()
    const firstThree = chats.slice(0, 3)

    if (open) return null

    // Render in inline mode only inside the sidebar (mobile/tablet);
    // render in floating mode only on desktop.
    if (isMobile && !inline) return null
    if (!isMobile && inline) return null

    return (
        <button
            className={`cfb${inline ? ' cfb--inline' : ''}`}
            onClick={toggle}
            preventLoading
        >
            {firstThree.length > 0 && (
                <div className="cfb__avatars">
                    {firstThree.map((chat, i) => (
                        <div
                            key={chat.id || i}
                            className="cfb__avatar"
                            style={{ zIndex: 3 - i, marginLeft: i > 0 ? -10 : 0 }}
                        >
                            {chat.avatar
                                ? <img src={chat.avatar} alt={chat.username} />
                                : <span>{getInitials(chat.username)}</span>
                            }
                        </div>
                    ))}
                </div>
            )}

            <Text.h4 id="cfb__label" weight={400} className="cfb__label">Mensagens</Text.h4>

            <div className="cfb__icon-wrap">
                <IconMessage size={22} strokeWidth={1.6} />
                {totalUnread > 0 && (
                    <span className="cfb__badge">+{totalUnread > 99 ? '99' : totalUnread}</span>
                )}
            </div>
        </button>
    )
}
